import { createWebHistory, createRouter } from "vue-router";
import i82n from './i18n';
import store from "./store";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from '@capacitor/keyboard';
import Home from "./components/home/HomeIndex.vue";
import CompanyRegistration from "./components/home/company-registration/CompanyRegistration.vue";
import ProductDetail from "./components/home/product/ProductDetail.vue";
import ProductDetailItem from "./components/home/product/ProductDetailItem.vue";
import ProductList from "./components/home/product/ProductList.vue";
import NotificationList from "./components/notification/NotificationList.vue";
import CartList from "./components/cart/CartList.vue";
import PaymentIndex from "./components/payment/PaymentIndex.vue";
import PaymentGateway from "./components/payment/PaymentGateway.vue";
import Transaction from "./components/transaction/TransactionIndex.vue";
import TransactionDetail from "./components/transaction/TransactionDetail.vue";
import TransactionStatusDetail from "./components/transaction/TransactionStatusDetail.vue";
import TransactionServiceDetail from "./components/transaction/TransactionServiceDetail.vue";
import Ticket from "./components/ticket/TicketIndex.vue";
import Profile from "./components/profile/ProfileIndex.vue";
import ProfileDetail from "./components/profile/ProfileDetail.vue";
import Language from "./components/profile/Language.vue";
import AddBranch from "./components/profile/company/AddBranch.vue";
import CompanyDetail from "./components/profile/company/CompanyDetail.vue";
import CompanyTransaction from "./components/profile/company/CompanyTransaction.vue";
import CompanyUser from "./components/profile/company/CompanyUser.vue";
import AddAccount from "./components/profile/AddAccount.vue";
import Login from "./components/auth/Login.vue";
import Register from "./components/auth/Register.vue";
import ForgotPassword from "./components/auth/ForgotPassword.vue";
import ResetPassword from "./components/auth/ResetPassword.vue";
import VerifyEmail from "./components/auth/VerifyEmail.vue";
import IframePage from "./components/IframePage.vue";

export let historyStack = [];

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/company-registration",
        name: "Company Registration",
        component: CompanyRegistration,
    },
    {
        path: "/product/detail",
        name: "Product Detail",
        component: ProductDetail,
    },
    {
        path: "/product/item",
        name: "Product",
        component: ProductDetailItem,
    },
    {
        path: "/product",
        name: "Product List",
        component: ProductList,
    },
    {
        path: "/notification",
        name: "Notification",
        component: NotificationList,
    },
    {
        path: "/cart",
        name: "Cart",
        component: CartList,
    },
    {
        path: "/payment",
        name: "Purchase Detail",
        component: PaymentIndex,
    },
    {
        path: "/payment-gateway",
        name: "Payment",
        component: PaymentGateway,
    },
    {
        path: "/transaction",
        name: "Transaction",
        component: Transaction,
    },
    {
        path: "/transaction/detail",
        name: "Transaction Details",
        component: TransactionDetail,
    },
    {
        path: "/transaction/status",
        name: "Status Details",
        component: TransactionStatusDetail,
    },
    {
        path: "/transaction/service",
        name: "Service Details",
        component: TransactionServiceDetail,
    },
    {
        path: "/ticket",
        name: "Open Ticket",
        component: Ticket,
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
    },
    {
        path: "/profile/detail",
        name: "Profile Details",
        component: ProfileDetail,
    },
    {
        path: "/profile/language",
        name: "Language",
        component: Language,
    },
    {
        path: "/add-branch",
        name: "Add Destination",
        component: AddBranch,
    },
    {
        path: "/profile/company",
        name: "Company Details",
        component: CompanyDetail,
    },
    {
        path: "/profile/company/transaction",
        name: "Company Purchase",
        component: CompanyTransaction,
    },
    {
        path: "/profile/company/user",
        name: "Company Account",
        component: CompanyUser,
    },
    {
        path: "/add-account",
        name: "Account Submission",
        component: AddAccount,
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/register",
        name: "Register",
        component: Register,
    },
    {
        path: "/forgot-password",
        name: "Forgot Password",
        component: ForgotPassword,
    },
    {
        path: "/reset-password",
        name: "Password",
        component: ResetPassword,
    },
    {
        path: "/verify-email",
        name: "Verify Email",
        component: VerifyEmail,
    },
    {
        path: "/iframe",
        name: "File Preview",
        component: IframePage,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    historyStack.push(to.fullPath);

    if (typeof Capacitor !== 'undefined' && Capacitor.isNativePlatform()) {
        Keyboard.hide();
    }
    let route_name = i82n.global.t(to.name);
    document.title = route_name + ' | ' + 'Assist';
    to.meta.title = route_name;
    const publicPages = ['/', '/login', '/register', '/forgot-password', '/reset-password', '/verify-email'];
    const authRequired = !publicPages.includes(to.path);
    const loggedData = localStorage.getItem('loggedData');

    // trying to access a restricted page + not logged in
    // redirect to login page
    if (authRequired && !loggedData) {
        next('/login');
    } else if (loggedData) {
        const expired_at = JSON.parse(loggedData).expired_at;
        const expired_at_date = new Date(expired_at);
        const now = new Date();
        if (now > expired_at_date) {
            store.dispatch('auth/logout');
            next('/login');
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;